import React from 'react';

import { Flex, Skeleton, SkeletonText, Spacer, Stack } from '@chakra-ui/react';

import style from './styles/DocumentListSkeleton.style';

const DocumentListSkeleton = () => {
  return (
    <Stack sx={style.root}>
      <DocRowSkeleton isOpen={true} />
      <Skeleton className="documentListSkeleton" />
      <DocRowSkeleton isOpen={false} />
      <Skeleton className="documentListSkeleton" />
      <DocRowSkeleton isOpen={false} />
    </Stack>
  );
};

const DocRowSkeleton = ({ isOpen = false }: { isOpen: boolean }) => {
  return (
    <Stack>
      <Flex className="documentListFlex">
        <SkeletonText className="documentListSkeletonText" skeletonHeight="3" />
      </Flex>
      {isOpen && (
        <>
          <Skeleton className="documentListSkeleton" />
          <Flex className="documentListFlex1">
            <Skeleton className="documentListSkeleton1" />
            <Stack className="documentListStack">
              <SkeletonText
                className="documentListSkeletonText1"
                skeletonHeight="3"
              />
              <SkeletonText
                className="documentListSkeletonText1"
                skeletonHeight="3"
              />
            </Stack>
            <Spacer />
            <SkeletonText
              className="documentListSkeletonText2"
              skeletonHeight="3"
            />
          </Flex>
          <Skeleton className="documentListSkeleton" />
          <Flex className="documentListFlex1">
            <Skeleton className="documentListSkeleton1" />
            <Stack className="documentListStack">
              <SkeletonText
                className="documentListSkeletonText1"
                skeletonHeight="3"
              />
              <SkeletonText
                className="documentListSkeletonText1"
                skeletonHeight="3"
              />
            </Stack>
            <Spacer />
            <SkeletonText
              className="documentListSkeletonText2"
              skeletonHeight="3"
            />
          </Flex>
        </>
      )}
    </Stack>
  );
};

export default DocumentListSkeleton;
